import './blog.css';

const Bloger = () => {
    return (
        <h1>Bloger</h1>
    )
}

export default Bloger;